module.exports = __webpack_public_path__ + "img/img-03.5e1b728d.jpg";